import voices from "../../data/voices.json";
import { Language, Voice, BotGender } from "./types";

const SAMPLE_SENTENCES: { [key in Language]: string } = {
  English: "Hi, my name is ",
  Spanish: "Hola, mi nombre es ",
  French: "Salut, je m'appelle ",
  Italian: "Ciao, mi chiamo ",
  Portuguese: "Oi, meu nome é ",
  German: "Hallo, mein Name ist ",
  Japanese: "こんにちは、私の名前は ",
  Korean: "안녕하세요, 제 이름은 ",
  Russian: "Привет, меня зовут ",
  Chinese: "你好，我的名字是 ",
  Arabic: "مرحبا، اسمي ",
  Dutch: "Hallo, mijn naam is ",
  Greek: "Γειά σας, το όνομά μου είναι ",
  Ukrainian: "Привіт, мене звати ",
  Polish: "Cześć, mam na imię ",
  Norwegian: "Hei, mitt navn er ",
  Danish: "Hej, mit navn er ",
  Finnish: "Hei, nimeni on ",
  Swedish: "Hej, mitt namn är ",
  Indonesian: "Halo, nama saya ",
};

const NAMES: { [key in Language]: { [gender in BotGender]: string } } = {
  English: { Male: "James", Female: "Emily", ["Non-binary"]: "Jordan" },
  Spanish: { Male: "Alejandro", Female: "Sofia", ["Non-binary"]: "Carmen" },
  French: { Male: "Lucas", Female: "Camille", ["Non-binary"]: "Sacha" },
  German: { Male: "Maximilian", Female: "Lena", ["Non-binary"]: "Luca" },
  Italian: { Male: "Matteo", Female: "Giulia", ["Non-binary"]: "Alessia" },
  Dutch: { Male: "Daan", Female: "Lotte", ["Non-binary"]: "Alex" },
  Portuguese: { Male: "João", Female: "Maria", ["Non-binary"]: "Alex" },
  Japanese: { Male: "Haruto", Female: "Sakura", ["Non-binary"]: "Haru" },
  Chinese: { Male: "Wei", Female: "Wei", ["Non-binary"]: "Rong" },
  Korean: { Male: "Minho", Female: "Hyejin", ["Non-binary"]: "Ara" },

  Russian: {
    Male: "Alexander",
    Female: "Anastasia",
    ["Non-binary"]: "Sasha",
  },

  Arabic: { Male: "Omar", Female: "Fatima", ["Non-binary"]: "Sami" },
  Greek: { Male: "Yiannis", Female: "Eleni", ["Non-binary"]: "Alex" },

  Ukrainian: {
    Male: "Andriy",
    Female: "Kateryna",
    ["Non-binary"]: "Sasha",
  },
  Polish: { Male: "Jakub", Female: "Katarzyna", ["Non-binary"]: "Alex" },
  Norwegian: { Male: "Magnus", Female: "Nora", ["Non-binary"]: "Alex" },
  Danish: { Male: "Magnus", Female: "Emma", ["Non-binary"]: "Alex" },
  Finnish: { Male: "Elias", Female: "Sofia", ["Non-binary"]: "Alex" },
  Swedish: { Male: "Oscar", Female: "Elsa", ["Non-binary"]: "Alex" },
  Indonesian: { Male: "Putri", Female: "Budi", ["Non-binary"]: "Dimas" },
};

export const getVoices = (language: Language, gender: BotGender): Voice[] => {
  const voiceData = voices?.[language] as any;
  const voiceGender = gender === "Female" ? "FEMALE" : "MALE";
  let ret = voiceData?.[voiceGender] || [];
  if (gender === "Non-binary") {
    ret = [...(voiceData?.FEMALE || []), ...(voiceData?.MALE || [])];
  }
  return ret.map((voice: any, index: number) => {
    return {
      label: `Voix #${index + 1}`,
      ...voice,
    };
  });
};

export const getSampleText = (language: Language, gender: BotGender) => {
  return `${SAMPLE_SENTENCES[language]} ${NAMES[language][gender]}`;
};
